import {EventEmitter, Injectable} from '@angular/core';
import {AtomicControllerService, AtomicTokenRequest} from "skyhopper-api";
import {Atomic, Product} from "@atomicfi/transact-javascript";
import {ATOMIC_AVAILABLE_KEY} from "../constants";
import {FacadeService} from "../service-facade/facade.service";
import {ApplicationLogDetailsRequest, ApplicationLogStepRequest} from "leia-api";
import {UtilitiesService} from "./utilities.service";
import OnboardingSourceEnum = ApplicationLogStepRequest.OnboardingSourceEnum;
import OnboardingStepEnum = ApplicationLogStepRequest.OnboardingStepEnum;
import OnboardingStateEnum = ApplicationLogStepRequest.OnboardingStateEnum;

@Injectable({
  providedIn: 'root'
})
export class AtomicService {

  public atomicErrorOccurredEvent = new EventEmitter<void>();

  constructor(  private atomicControllerService: AtomicControllerService,
                private facadeService: FacadeService,
                private utilitiesService: UtilitiesService) { }

  isAtomicAvailable() : boolean {
    let isAtomicAvailable = this.facadeService.getStorageItemAsBoolean(ATOMIC_AVAILABLE_KEY);

    if (this.facadeService.isFromBranch() || this.facadeService.isInJointMaintenanceFlow())
      isAtomicAvailable = false;

    return isAtomicAvailable;
  }

  async launchAtomicSdk(sessionId : string) {
    let atomicTokenRequest : AtomicTokenRequest = {} as AtomicTokenRequest;
    atomicTokenRequest.sessionId = sessionId;

    try {
      this.atomicControllerService.getAccessToken(atomicTokenRequest).subscribe(response => {
        if (!response.token) { return; }

        Atomic.transact({
          config: {
            publicToken: response.token,
            tasks: [{ product: Product.DEPOSIT }],
            metadata: {
              "source": "BB8"
            }
          },
          onInteraction: async (interaction: any) => {
            let applicationRequest = this.facadeService.getShoppingCartApplicationLogsRequest();

            let applicationLogDetailRequests: ApplicationLogDetailsRequest[] = [];
            applicationLogDetailRequests.push(this.utilitiesService.createApplicationLogDetailsRequest(OnboardingSourceEnum.Bb8, 'Atomic Interaction. Event: ' + interaction.name + '.'));

            applicationRequest.applicationLogDetailsRequestList = applicationLogDetailRequests;

            this.facadeService.setShoppingCartApplicationLogsRequest(applicationRequest);
            await this.facadeService.updateApplication();
          },
          onFinish: async (data : any) => {
            let applicationRequest = this.facadeService.getShoppingCartApplicationLogsRequest();

            let applicationLogStepRequest = this.utilitiesService.createApplicationLogStepRequest(OnboardingStepEnum.DirectDeposit, OnboardingStateEnum.Success, OnboardingSourceEnum.Bb8, [this.utilitiesService.createApplicationLogDetailsRequest(OnboardingSourceEnum.Bb8, 'Atomic Finished. Task ID: ' + data.taskId + '.')]);

            applicationRequest.applicationLogStepRequest = applicationLogStepRequest;

            this.facadeService.setShoppingCartApplicationLogsRequest(applicationRequest);
            await this.facadeService.updateApplication();
          },
          onClose: async (data : any) => {
            let applicationRequest = this.facadeService.getShoppingCartApplicationLogsRequest();

            let applicationLogStepRequest = this.utilitiesService.createApplicationLogStepRequest(OnboardingStepEnum.DirectDeposit, OnboardingStateEnum.Success, OnboardingSourceEnum.Bb8, [this.utilitiesService.createApplicationLogDetailsRequest(OnboardingSourceEnum.Bb8, 'Atomic Closed. Reason: ' + data.reason + '.')]);

            applicationRequest.applicationLogStepRequest = applicationLogStepRequest;

            this.facadeService.setShoppingCartApplicationLogsRequest(applicationRequest);
            await this.facadeService.updateApplication();
          }
        });
      });
    } catch (e) {
      let applicationRequest = this.facadeService.getShoppingCartApplicationLogsRequest();
      let applicationLogStepRequest = this.utilitiesService.createApplicationLogStepRequest(OnboardingStepEnum.DirectDeposit, OnboardingStateEnum.Fail, OnboardingSourceEnum.Bb8, [this.utilitiesService.createApplicationLogDetailsRequest(OnboardingSourceEnum.Bb8, 'Atomic exception occurred. Exception: ' + e + '.')]);

      applicationRequest.applicationLogStepRequest = applicationLogStepRequest;

      this.facadeService.setShoppingCartApplicationLogsRequest(applicationRequest);
      await this.facadeService.updateApplication();

      this.atomicErrorOccurredEvent.emit();
    }
  }
}
